import { DropdownItem } from '@factorialco/f0-react/dist/experimental'
import { IntegrationsSyncableStateStatusEnum } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import { GroupedStatus, groupedStatuses } from 'modules/integrations/lib/syncableStatus'

const getTooltipTranslation = (groupedStatus: GroupedStatus, isExportMode: boolean): string => {
  if (isExportMode) {
    switch (groupedStatus) {
      case 'syncing':
        return i18n.t('integrations.export_tooltips.exporting')
      case 'pending':
        return i18n.t('integrations.export_tooltips.pending')
      case 'outdated':
        return i18n.t('integrations.export_tooltips.outdated')
      case 'partially_synced':
        return i18n.t('integrations.export_tooltips.partially_exported')
      case 'failed':
        return i18n.t('integrations.export_tooltips.failed')
      case 'synced':
        return i18n.t('integrations.export_tooltips.exported')
      default:
        throw new Error(`Unknown grouped status: ${groupedStatus}`)
    }
  }

  switch (groupedStatus) {
    case 'syncing':
      return i18n.t('integrations.sync_tooltips.syncing')
    case 'pending':
      return i18n.t('integrations.sync_tooltips.pending')
    case 'outdated':
      return i18n.t('integrations.sync_tooltips.outdated')
    case 'partially_synced':
      return i18n.t('integrations.sync_tooltips.partially_synced')
    case 'failed':
      return i18n.t('integrations.sync_tooltips.failed')
    case 'synced':
      return i18n.t('integrations.sync_tooltips.synced')
    default:
      throw new Error(`Unknown grouped status: ${groupedStatus}`)
  }
}

export const statusesItems = (
  statusesGroups: Set<IntegrationsSyncableStateStatusEnum>[],
  isExportMode: boolean
): DropdownItem[] => {
  const items: DropdownItem[] = []

  groupedStatuses(statusesGroups)
    .reduce((map, groupedStatus) => {
      map.set(groupedStatus, (map.get(groupedStatus) ?? 0) + 1)
      return map
    }, new Map<GroupedStatus, number>())
    .forEach((value, key) => {
      if (key === 'syncing') return

      items.push({
        label: `${getTooltipTranslation(key, isExportMode)}: ${value}`,
        critical: key === 'failed',
      })
    })

  return items
}
